export * from './lib/shared-utils-directives.module';
export * from './lib/click-outside.directive';
export * from './lib/dynamic-text-color.directive';
